import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
  selector: "app-imported-payload-view",
  templateUrl: "./imported-payload-view.component.html",
  styleUrls: ["./imported-payload-view.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportedPayloadViewComponent {
  readonly payload = input<string | null | undefined>(null);
  readonly title = input<string>("Payload");
  readonly emptyMessage = input<string>("No payload available");

  readonly hasPayload = computed(() => {
    const v = this.payload();
    return typeof v === "string" && v.trim().length > 0;
  });

  readonly formatted = computed(() => {
    const v = this.payload();
    if (typeof v !== "string" || v.trim().length === 0) return "";

    try {
      return JSON.stringify(JSON.parse(v), null, 2);
    } catch {
      return v;
    }
  });
}
